import React, { useEffect, useState } from 'react'
import { AppProps } from '../../App'
import { useNavigate, useParams } from 'react-router-dom';
import Loading from '../../components/Loading';
import { ProjectModel } from '../../utils/interfaces';
import { useAsyncEffect } from '../../utils/functions';
import { tables } from '../../utils/constants';
import { getItem } from '../../api/API';
import MainWrapper from '../../components/MainWrapper';
import Overview from './Overview';
import Config from './Config';
import Auth from './Auth/Auth';
import Database from './Database/Database';
import Storage from './Storage/Storage';
import DatabaseManage from './Database/DatabaseManage';
import StorageManage from './Storage/StorageManage';
import Function from './Function/Function';
import FunctionManage from './Function/FunctionManage';

export interface ProjectProps extends AppProps {
  project: ProjectModel
  setProject: React.Dispatch<React.SetStateAction<ProjectModel | null | undefined>>
}

const Project = (props: AppProps) => {

  const params = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState<ProjectModel | null | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);

  // check if user is signed in
  useEffect(() => {
    if (!props.user) {
      navigate('/signin');
      return
    }
    if (props.user.plan.name === 'free') {
      navigate('/pricing');
      return;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.user]);

  // load project
  useAsyncEffect(async () => {
    if (!params.projectId) {
      navigate('/');
      return;
    }
    const data = await getItem(tables.projects, params.projectId);
    if (data.item) {
      // check if user is authorized
      if (!data.item?.adminIds.find((admin: { userId: string, access: 'read_only' | 'full_access' }) => admin.userId === props.user?.id)) {
        navigate('/unauthorized');
        return;
      }
      // update last access time and set current app
      const newProject: ProjectModel = { ...data.item };
      setProject(newProject); 
    } else { // project not found
      navigate('/pagenotfound');
      return;
    }
    setIsLoading(false);
  }, [params.projectId]);

  return (
    isLoading ? <main className='flex items-center justify-center flex-1'><Loading solid size={8} /></main>
    : project ? <>
      <MainWrapper {...props} padding={0}>
        {!params.service ? <Overview {...props} project={project} setProject={setProject} /> 
        : params.service === 'auth' ? <Auth {...props} project={project} setProject={setProject} />
        : params.service === 'database' ? (
          params.serviceName ? <DatabaseManage {...props} project={project} setProject={setProject} /> : <Database {...props} project={project} setProject={setProject} />
        ) : params.service === 'storage' ? (
          params.serviceName ? <StorageManage {...props} project={project} setProject={setProject} /> : <Storage {...props} project={project} setProject={setProject} />
        ) : params.service === 'function' ? (
          params.serviceName ? <FunctionManage {...props} project={project} setProject={setProject} /> : <Function {...props} project={project} setProject={setProject} />
        )
        : params.service === 'config' ? <Config {...props} project={project} setProject={setProject} />
        : <></>}
      </MainWrapper>
    </> : <></>
  )
}

export default Project